const env = import.meta.env;

/** Local chatbot backend (no trailing slash). Override with VITE_CHATBOT_API_URL. */
export const chatbotApi =
  (env.VITE_CHATBOT_API_URL as string | undefined)?.replace(/\/$/, '') ||
  'http://localhost:8000';

export const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY as string | undefined,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined,
  databaseURL: env.VITE_FIREBASE_DATABASE_URL as string | undefined,
  projectId: env.VITE_FIREBASE_PROJECT_ID as string | undefined,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET as string | undefined,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID as string | undefined,
  appId: env.VITE_FIREBASE_APP_ID as string | undefined,
};

export function isFirebaseConfigured(): boolean {
  return Boolean(
    firebaseConfig.apiKey &&
      firebaseConfig.authDomain &&
      firebaseConfig.databaseURL &&
      firebaseConfig.projectId &&
      firebaseConfig.appId,
  );
}

export const emailJsConfig = {
  serviceId: env.VITE_EMAILJS_SERVICE_ID as string | undefined,
  templateId: env.VITE_EMAILJS_TEMPLATE_ID as string | undefined,
  publicKey: env.VITE_EMAILJS_PUBLIC_KEY as string | undefined,
};

export function isEmailJsConfigured(): boolean {
  return Boolean(emailJsConfig.serviceId && emailJsConfig.templateId && emailJsConfig.publicKey);
}

export const appUrl =
  (env.VITE_APP_URL as string | undefined)?.replace(/\/$/, '') ||
  (typeof window !== 'undefined' ? window.location.origin : '');
